import { render } from "./TaxReliefCalculator.vue?vue&type=template&id=3a055eae&scoped=true"
import script from "./TaxReliefCalculator.vue?vue&type=script&lang=js"
export * from "./TaxReliefCalculator.vue?vue&type=script&lang=js"

import "./TaxReliefCalculator.vue?vue&type=style&index=0&id=3a055eae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a055eae"]])

export default __exports__